import { toolbar_defaults } from './defaults';

export * from './defaults';
export class Toolbar {
  static Index = toolbar_defaults.index;
  static Create = toolbar_defaults.create;
  static Edit = toolbar_defaults.edit;
  static View = toolbar_defaults.view;
}
